import { render, staticRenderFns } from "./VideoPacket.vue?vue&type=template&id=770d929c&"
import script from "./VideoPacket.vue?vue&type=script&lang=js&"
export * from "./VideoPacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports